require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-seattle-startup-week-2016.json") })
        }
      }, "path---blog-seattle-startup-week-2016");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-seattle-startup-week-2016!./.cache/json/blog-seattle-startup-week-2016.json
// module id = 1014
// module chunks = 231608221292675